import { render, staticRenderFns } from "./Statute.vue?vue&type=template&id=a1581310&scoped=true&"
import script from "./Statute.vue?vue&type=script&lang=js&"
export * from "./Statute.vue?vue&type=script&lang=js&"
import style0 from "./Statute.vue?vue&type=style&index=0&id=a1581310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1581310",
  null
  
)

export default component.exports